import { Controller } from "@hotwired/stimulus"

/**
 * Toggles between single-value and range inputs for date filters
 * based on the selected operator. "between" shows the range pair,
 * "any" hides both, and all other operators show the single input.
 *
 * Connects to data-controller="date-filter"
 *
 * Usage:
 *   <div data-controller="date-filter" data-date-filter-op-value="eq">
 *     <select data-date-filter-target="op"
 *             data-action="change->date-filter#switchMode">
 *       <option value="any">Any</option>
 *       <option value="eq">=</option>
 *       <option value="between">Between</option>
 *     </select>
 *     <span data-date-filter-target="single">
 *       <input type="date" />
 *     </span>
 *     <span data-date-filter-target="range" class="hidden">
 *       <input type="date" placeholder="From" />
 *       <input type="date" placeholder="To" />
 *     </span>
 *   </div>
 */
export default class extends Controller {
  static targets = ["op", "single", "range"]
  static values = {
    op: { type: String, default: "eq" },
  }

  declare readonly opTarget: HTMLSelectElement
  declare readonly singleTarget: HTMLElement
  declare readonly rangeTarget: HTMLElement
  declare readonly opValue: string

  connect() {
    this.switchMode()
  }

  switchMode() {
    const op = this.opTarget.value

    if (op === "any") {
      this.singleTarget.classList.add("hidden")
      this.rangeTarget.classList.add("hidden")
    } else if (op === "between") {
      this.singleTarget.classList.add("hidden")
      this.rangeTarget.classList.remove("hidden")
    } else {
      this.singleTarget.classList.remove("hidden")
      this.rangeTarget.classList.add("hidden")
    }
  }
}
